import { Card, CardContent, CardHeader } from '@/shared/ui/Card';
import { Skeleton } from '@/shared/ui/Skeleton';
import styles from '../OnboardingPage.module.css';

export function OnboardingSkeleton() {
  return (
    <div className={styles.page}>
      <div className={styles.shell}>
        <Card className={styles.skeletonCard}>
          <div className={styles.skeletonProgressBarTrack}>
            <Skeleton width="15%" height="100%" borderRadius="0" />
          </div>
          <CardHeader className={styles.cardHeader}>
            <div className={styles.skeletonHeader}>
              <Skeleton width={180} height={24} />
              <Skeleton width="100%" height={18} />
              <Skeleton width="80%" height={18} />
            </div>
          </CardHeader>
          <CardContent className={styles.cardContent}>
            <div className={styles.skeletonGrid}>
              <div className={styles.field}>
                <Skeleton width={100} height={18} />
                <Skeleton width="100%" height={36} borderRadius="var(--radius-lg)" />
              </div>
              <div className={styles.field}>
                <Skeleton width={100} height={18} />
                <Skeleton width="100%" height={36} borderRadius="var(--radius-lg)" />
              </div>
              <div className={styles.fieldSpan}>
                <Skeleton width={100} height={18} />
                <Skeleton width="100%" height={36} borderRadius="var(--radius-lg)" />
              </div>
              <div className={styles.fieldSpan}>
                <Skeleton width={100} height={18} />
                <Skeleton width="100%" height={36} borderRadius="var(--radius-lg)" />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
